import {useState} from 'react';
import {Button, Card, Descriptions, Typography} from 'antd';
import UserLink from 'components/userLink/UserLink';
import {personName, websiteHref} from '../kybUtils';
import styles from '../kybDashboard.module.scss';

const {Text} = Typography;

/** Past either limit, the description starts clamped. */
const LONG_DESCRIPTION_CHARS = 280;
const LONG_DESCRIPTION_LINES = 4;

export const isLongDescription = text =>
  Boolean(text) &&
  (text.length > LONG_DESCRIPTION_CHARS ||
    text.split('\n').length > LONG_DESCRIPTION_LINES);

const Description = ({text}) => {
  const [expanded, setExpanded] = useState(false);
  if (!text?.trim()) return '—';
  const long = isLongDescription(text);
  return (
    <div>
      <p
        className={
          long && !expanded
            ? `${styles.kybProfileText} ${styles.kybProfileClamped}`
            : styles.kybProfileText
        }>
        {text}
      </p>
      {long && (
        <Button
          type="link"
          size="small"
          className={styles.kybProfileToggle}
          onClick={() => setExpanded(value => !value)}>
          {expanded ? 'Show less' : 'Show more'}
        </Button>
      )}
    </div>
  );
};

const Website = ({website}) => {
  if (!website?.trim()) return '—';
  const href = websiteHref(website);
  if (!href) return <span>{website}</span>;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.kybProfileWebsite}>
      {website}
    </a>
  );
};

/**
 * What the business says it does, where it lives online, and who administers
 * the account.
 *
 * The administrator is the one person here with a user record, so their name
 * opens their KYC page — their own verification is the other half of the
 * account going live.
 */
export const KybBusinessProfile = ({account}) => {
  const contact = account?.primaryContact;
  return (
    <Card title="Business profile" className={styles.card}>
      <Descriptions column={1} size="small" colon={false}>
        <Descriptions.Item label="Description">
          <Description text={account?.businessDescription} />
        </Descriptions.Item>
        <Descriptions.Item label="Website">
          <Website website={account?.website} />
        </Descriptions.Item>
        <Descriptions.Item label="Administrator">
          {contact?.id ? (
            <div className={styles.entityCell}>
              <UserLink userId={contact.id} tab="kyc-status">
                {personName(contact)}
              </UserLink>
              {contact.email && (
                <Text type="secondary" className={styles.subtle}>
                  {contact.email}
                </Text>
              )}
            </div>
          ) : (
            '—'
          )}
        </Descriptions.Item>
        <Descriptions.Item label="Administrator nationality">
          {account?.administratorNationality || '—'}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};
